import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

import useCanEdit from '../../hooks/useCanEdit'
import GeneralForm from '../../pages/CompanyDataPage/CompanyDataGeneralForm/GeneralForm'
import styles from './styles.module.scss'

const InfoModal = ({ onClose }) => {
  const companyData = useSelector((state) => state.company)
  const isCanEdit = useCanEdit()

  const handleOverlayClick = (event) => {
    if (event.target === event.currentTarget) {
      onClose()
    }
  }

  return (
    <div className={styles.overlay} onMouseDown={handleOverlayClick}>
      <div className={styles.popup}>
        <button type="button" className={styles.closeButton} onClick={onClose} aria-label="Close modal">
          ×
        </button>

        <p className={styles.infoText}>To access this feature, please complete company verification.</p>

        <div className={styles.formWrapper}>
          <GeneralForm
            isCanEdit={isCanEdit}
            companyData={companyData}
            hideLogoEditor
            withPageSideEffects={false}
          />
        </div>
      </div>
    </div>
  )
}

InfoModal.propTypes = {
  onClose: PropTypes.func.isRequired,
}

export default InfoModal
